// @ts-ignore
/* eslint-disable */
import { request } from '@/services/transit.request';

/** Lấy danh sách tất cả transit tags GET /api/v1/transit-tags */
export async function transitTagsGetAll(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitTagsGetAllParams,
  options?: { [key: string]: any },
) {
  return request<API.TransitTag[]>('/api/v1/transit-tags', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Tạo mới transit tag POST /api/v1/transit-tags */
export async function transitTagsCreate(
  body: API.CreateTransitTagDto,
  options?: { [key: string]: any },
) {
  return request<API.TransitTag>('/api/v1/transit-tags', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Lấy thông tin transit tag theo ID GET /api/v1/transit-tags/${param0} */
export async function transitTagsGetById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitTagsGetByIdParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.TransitTag>(`/api/v1/transit-tags/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** Cập nhật transit tag PUT /api/v1/transit-tags/${param0} */
export async function transitTagsUpdate(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitTagsUpdateParams,
  body: API.UpdateTransitTagDto,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<API.TransitTag>(`/api/v1/transit-tags/${param0}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** Xóa transit tag DELETE /api/v1/transit-tags/${param0} */
export async function transitTagsDelete(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.transitTagsDeleteParams,
  options?: { [key: string]: any },
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/transit-tags/${param0}`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  });
}
